import { render, staticRenderFns } from "./template.html?vue&type=template&id=6fa446bc&scoped=true&"
import script from "./thanks.vue?vue&type=script&lang=js&"
export * from "./thanks.vue?vue&type=script&lang=js&"
import style0 from "../404/styles.css?vue&type=style&index=0&id=6fa446bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa446bc",
  null
  
)

export default component.exports